import React, { useEffect, useState, useCallback } from "react";
import { TABLE_HEADERS } from "../admin/maintenance/constants";
import { createStyles, Theme } from "@material-ui/core/styles";
import { AccessProvisioner, getRequestForAccessProvisionerPaginated } from "@api/request/provisioners";
import { MaintenanceBreadcrumbs } from "../admin/maintenance/breadcrumbs";
import DataTable from "react-data-table-component";
import { Box, Grid, Button, Typography } from "@material-ui/core";
import { Search } from "@components/table/toolbar/search-filters";
import { useHistory } from "react-router-dom";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import { Form } from "@components/index";
const columns = [
  {
    name: TABLE_HEADERS.REF_NUMBER,
    selector: "referenceNumber",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.EFFECTIVE_DATE,
    selector: "effectiveDate",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.REQUEST_TYPE,
    selector: "requestType",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.USER,
    selector: "userName",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.REQUESTOR,
    selector: "requestor",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.STATUS,
    selector: "status",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.RF_NO,
    selector: "serviceTicketNumber",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.SYSTEM_CATEGORY,
    selector: "category",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.DEVICE_TYPE,
    selector: "deviceType",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.NAME,
    selector: "subCategory",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.ENVIRONMENT,
    selector: "environment",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.ROLE,
    selector: "roleName",
    sortable: true,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
};

export const AccessProvisioners: React.FC = () => {
  const history = useHistory();
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [page, setPage] = React.useState<number>(1);
  const [perPage] = React.useState<number>(10);
  const [total, setTotal] = React.useState<number>(0);
  const [counter, updateCounter] = React.useState(0);
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [uam, setUam] = useState<[]>([]);
  const [sortBy, setSortBy] = useState("" || "desc");
  const [sortItem, setSortItem] = useState("" || "effectiveDate");
  const [stat_APPROVED, setAPPROVED] = useState<boolean>(true);
  const [stat_INPROGRESS, setINPROGRESS] = useState<boolean>(false);
  const [stat_COMPLETED, setCOMPLETED] = useState<boolean>(false);
  const [stat_REJECTED, setREJECTED] = useState<boolean>(false);
  const [stat_DECLINED, setDECLINED] = useState<boolean>(false);
  const [stat_RFDECLINED, setRFDECLINED] = useState<boolean>(false);
  useEffect(() => {
    fetchUam();
  }, [counter, page, searchQuery, sortItem, sortBy]);

  function fetchUam() {
    setIsloading(true);
    getRequestForAccessProvisionerPaginated(
      page,
      perPage,
      searchQuery,
      sortItem,
      sortBy,
      stat_APPROVED,
      stat_INPROGRESS,
      stat_COMPLETED,
      stat_REJECTED,
      stat_RFDECLINED,
      stat_DECLINED
    )
      .then((response: any) => {
        setUam(response.requests);
        setTotal(response.totalRequests);
        setIsloading(false);
      })
      .finally(() => {
        setIsloading(false);
      });
  }

  const onSearchUpdate = useCallback((term: string) => {
    setSearchQuery(term);
  }, []);

  const handleSort = (column: any, sortDirection: any) => {
    console.log(column);
    setSortItem(column.selector);
    setSortBy(sortDirection);
  };

  //apply filters
  function filterByStatus() {
    fetchUam();
  }

  const pageName = "UAM";
  return (
    <Box mt={2}>
      
      <Grid item xs={12}>
        <Typography variant="h6">Access Provisioners</Typography>
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="flex-end"
      >
        
      </Grid>
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={4}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Reference No. or RF No."}
          ></Search>
        </Grid>
      </Grid>
      <DataTable
        columns={columns}
        data={uam}
        highlightOnHover
        pagination
        paginationServer
        paginationTotalRows={total}
        paginationPerPage={perPage}
        onSort={handleSort}
        sortServer
        persistTableHead
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
        pointerOnHover
        onChangePage={(page) => setPage(page)}
        paginationRowsPerPageOptions={[10, 30, 50]}
        onChangeRowsPerPage={(page) => setPage(page)}
        data-tag="allowRowEvents"
        progressPending={isLoading}
        progressComponent={<LinearIndeterminate />}
        onRowClicked={(data: any) => {
          history.push(`/dashboard/requests/${data.encryptId}`, {
            readonlyAttestation: true,
          });
        }}
      />
    </Box>
  );
};
